export default "__VITE_ASSET__RaD0_VgG__"